import { InputWrapper } from '@mantine/core';
import inputWrapperClasses from './input-wrapper.module.css';
import { defaultInputProps } from '../default-props';
export const inputWrapperProps = InputWrapper.extend({
    classNames: inputWrapperClasses,
    defaultProps: defaultInputProps,
});
